import * as styles from './styles';
import { BreadcrumbItem } from './BreadcrumbItem';
import { StyledBreadcrumbs } from './StyledBreadcrumbs';

import type { Breadcrumb } from '@cobliteam/common-types';

import { ChevronIcon } from '../icons';

interface BreadcrumbsProps<T> {
  breadcrumbs: Breadcrumb<T>[];
  selectedBreadcrumb: Breadcrumb<T>;
  onBreadcrumbClick?: (breadcrumb: Breadcrumb<T>) => void;
  onReturnButtonClick?: () => void;
  className?: string;
}

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
export const Breadcrumbs = <T extends string>({ breadcrumbs, onBreadcrumbClick, onReturnButtonClick, selectedBreadcrumb, className }: BreadcrumbsProps<T>) => {
  const canBeClicked = (breadcrumbId: string) => {
    const breadIndex = breadcrumbs.findIndex((b) => b.id === breadcrumbId);
    const currentSelectedBreadIndex = breadcrumbs.findIndex((b) => b.id === selectedBreadcrumb.id);

    if (breadcrumbs[breadIndex].disabledClick) {
      return false;
    }

    return breadIndex <= currentSelectedBreadIndex;
  };

  return (
    <div className={`${styles.breadcrumbs} ${className || ''}`}>
      {onReturnButtonClick && <ChevronIcon className={styles.returnButton} onClick={onReturnButtonClick} />}
      <StyledBreadcrumbs separator={<ChevronIcon className={styles.separator} />}>
        {breadcrumbs.map((breadcrumb) => (
          <BreadcrumbItem
            key={breadcrumb.id}
            breadcrumb={breadcrumb}
            disabled={!canBeClicked(breadcrumb.id)}
            selectedBreadcrumb={selectedBreadcrumb}
            onBreadcrumbClick={onBreadcrumbClick}
          />
        ))}
      </StyledBreadcrumbs>
    </div>
  );
};
